import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AuthService } from "../../services/auth.service";
import { environment } from "src/environments/environment";

@Component({
    selector: "app-login-page",
    templateUrl: "./login-page.component.html",
    styleUrls: ["./login-page.component.scss"],
})
export class LoginPageComponent {
    readonly socialEnabled = environment.enableSocialLogin && !!environment.apiUrl;
    returnUrl: string | null = null;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly auth: AuthService,
    ) {
        this.route.queryParamMap.subscribe((params) => {
            this.returnUrl = params.get("returnUrl");
        });
    }

    onAuthenticated(): void {
        this.auth.navigateAfterAuth(this.returnUrl);
    }
}
